import React from "react";

export default function SuccessToster({ successMessage }) {
  return (
    <div className="flex flex-row justify-center items-center gap-2   min-h-[44px] px-[21px] rounded-[10px] bg-pkt-d3eddb">
      <img
        src={`${process.env.PUBLIC_URL || ""}/images/toaster/success.svg`}
        alt=""
        className="w-[14px] h-[14px]"
      />
      <span className="text-xs font-medium text-pkt-1BA843">
        {successMessage}
      </span>
    </div>
  );
}
